// ProfileHeader.jsx
function ProfileHeader({ activeTab, setActiveTab }) {
  const items = [
    { key: "profile", label: "Profile", icon: "profile.png" },
    { key: "education", label: "Education", icon: "education.png" },
    { key: "skill", label: "Skills", icon: "skill.png" },
    { key: "work", label: "Work Experience", icon: "working-time.png" },
    { key: "resume", label: "Resume", icon: "cv.png" },
    { key: "hourleeresume", label: "Hourlee Resume", icon: "resume.png" },
  ];

  return (
    <div className="row">
      {items.map((item) => (
        <div className="col-6 col-md-2 mb-4" key={item.key}>
          <button
            onClick={() => setActiveTab(item.key)}
            className={`card text-center text-decoration-none h-100 ${
              activeTab === item.key ? "cactive" : ""
            }`}
            style={{ border: "none", background: "transparent" }}
          >
            <div className="ccard-body">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/myimg/${item.icon}`}
                alt={item.label}
              />
              <h5>{item.label}</h5>
            </div>
          </button>
        </div>
      ))}
    </div>
  );
}

export default ProfileHeader;
